import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

type Module =
    | 'RENTING'
    | 'TOURNAMENT'
    | 'EVENT'
    | 'GAME'
    | 'CLASS'
    | 'SALE_POINT'
    | 'PURSE'
    | 'ABONADOS'
    | 'BONO'
    | 'UNKNOWN'
    | 'BUY_BONO'
    | 'BUY_ABONO'
    | 'UNIFIED';

type Props = {
    module: Module;
};

/**
 * Modules
 */
export function SttChipModule({ module }: Props): React.ReactElement {
    const { t } = useTranslation();

    const color: Record<Module, string> = {
        RENTING: '#ff5353',
        TOURNAMENT: '#19cc3a',
        EVENT: '#19cc3a',
        GAME: '#4768fd',
        CLASS: '#fd66bc',
        SALE_POINT: '#8a6d3b',
        PURSE: '#3186a7',
        ABONADOS: '#8a3930',
        BONO: '#269c97',
        UNKNOWN: '#9e9e9e',
        BUY_BONO: '#269c97',
        BUY_ABONO: '#8a3930',
        UNIFIED: '#6b5b95',
    };

    return (
        <>
            {module && (
                <Chip
                    size="small"
                    label={t(`modules.${module.toLowerCase()}`)}
                    style={{ ...chipColors(color[module]) }}
                />
            )}
        </>
    );
}
